const customCollapseList = [
        {
            id:1,
            title:'What type of travel packages does bbg offer?',
            desc:'BBG Move offers a wide range of travel packages to destinations around the China, including customized tours, group tours, luxury travel, and more. Our travel specialists work with you to create an itinerary that meets your specific needs and preferences.',
            desc1:'',
            list:[]
        },
        {
            id:2,
            title:'What happens after booking ?',
            desc:'Shortly after booking, your guest services manager will email you more details about your trip. This dedicated professional will be your main point of contact. He or she will provide you additional information leading up to your departure and is available to answer any questions via phone or email.',
            desc1:'Prior to departure, you will receive a set of amenities for your trip. These may include a wheeled bag, a backpack, packing cubes and other useful travel items.',
            list:[]
        },
        {
            id:3,
            title:'Group travel redefined',
            desc:'Our trips are a unique opportunity for like-minded travelers who are interested in learning and exploring to come together. The strong friendships forged on our trips continue long after guests return home and open the door to more travel adventures.',
            desc1:'On expeditions with 48 or more travelers, daily activities will be divided into intimate groups of 6 to 12, so you never feel like you’re part of a crowd. On all trips, we offer numerous activity options at each destination such as: guided small-group sightseeing, curated shopping, and exclusive visits to museums and landmarks. Other examples include more active options like hikes or snorkeling, as well as unforgettable moments like an intimate guided exploration of Angkor Wat and our hot-air balloon ride over the Serengeti. ',
            list:[]
        },
        {   id:4,
            title:'Trip Activity Levels',
            desc:'Our journey offers different levels of travel experiences for you to choose from, tailored to your budget and preferences.There are three tiers available, corresponding to economy vehicles, luxury vehicles, or supercars, among others.',
            desc1:'',
            list:[]
        },
        {   id:5,
            title:'Your Health',
            desc:'No information at the moment, please stay tuned',
            desc1:'',
            list:[]
        },
        {   id:6,
            title:'Passports and Visas',
            desc:'All guests must have valid passports to participate in this program. Passports must be valid at least 6 months beyond the end date of your expedition. If visas are required for the expedition, a visa kit will be sent to you approximately between 6 and 3 months prior to departure depending on destination requirements. We work with an expediting service that helps make getting your required visas easier. Although you’re still required to fill out your visa forms and cover the application costs, they will review the application to make sure it\'s complete and liaise with the necessary consulates and embassies to process your visas.',
            desc1:'',
            list:[]
        },
        {   id:7,
            title:'What\'s Included',
            desc:'No information at the moment, please stay tuned',
            desc1:'',
            list:[
                {
                    id:1,
                    title:'Your expedition includes:',
                    itemList:[
                        {
                            id:1,
                            content:'First-class accommodations',
                        },
                        {
                            id:2,
                            content:'Ground transportation',
                        },
                        {
                            id:3,
                            content:'All meals and beverages, including select beer, wine and spirits aboard the jet and group lunches and dinners',
                        },
                        {
                            id:4,
                            content:'All sightseeing activities, from guided small-group excursions and private shopping to more active options such as snorkeling and hikes',
                        },
                        {
                            id:5,
                            content:'Special events and private access',
                        },
                        {
                            id:6,
                            content:'Top local guides and/or on-trip experts',
                        },
                        {
                            id:7,
                            content:'A veteran expedition team who handles all logistics',
                        },
                        {
                            id:8,
                            content:'On some itineraries, a trip physician who accompanies you throughout your journey',
                        },
                        {
                            id:9,
                            content:'Luggage handling',
                        }
                    ]
                },
                {
                    id:2,
                    title:'Your expedition does not include:',
                    itemList:[
                        {
                            id:1,
                            content:'Commercial airfare between your home city and departure/arrival destination',
                        },
                        {
                            id:2,
                            content:'Optional and additional accident/baggage/cancellation insurance',
                        },
                        {
                            id:3,
                            content:'Passport and visa fees',
                        },
                        {
                            id:4,
                            content:'Personal expenses such as laundry, telephone and fax fees',
                        },
                        {
                            id:5,
                            content:'All beverages not mentioned above as included',
                        },
                        {
                            id:6,
                            content:'Hotel minibar charges',
                        },
                        {
                            id:7,
                            content:'Meals not scheduled by BBG Plus',
                        },
                        {
                            id:8,
                            content:'Inoculation and medication costs of any kind',
                        },
                    ]
                }
            ]
        },
        {   id:8,
            title:'How Payment Works',
            desc:'No information at the moment, please stay tuned',
            desc1:'',
            list:[]
        },
        {   id:9,
            title:'Solo Supplement',
            desc:'If you are traveling solo and prefer the privacy of your own room, you will be charged a solo traveler supplement. This ensures that individual travelers will get the same type and size rooms as our double occupancy travelers.',
            desc1:'',
            list:[]
        },
        {   id:10,
            title:'Trip Insurance and Emergencies',
            desc:'No information at the moment, please stay tuned',
            desc1:'',
            list:[]
        },
    
]
export default {
    customCollapseList
}